import { type FC, type ReactNode } from 'react';
import classNames from 'classnames';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

// styles
import dibsCss from 'dibs-css';
import styles from './SbSharedL1FeaturedTile.scss';

type Props = {
    mainImage?: string | null;
    heading?: ReactNode;
    subHeading?: ReactNode;
    fullWidth?: boolean;
    children?: FC<{ className: string; children: ReactNode }>;
};

export const SbSharedL1FeaturedTile: FC<Props> = ({
    mainImage,
    heading,
    subHeading,
    fullWidth,
    children,
}) => {
    if (!mainImage) {
        return null;
    }

    const tile = (
        <>
            <div
                className={classNames(
                    styles.imageContainer,
                    dibsCss.relative,
                    fullWidth && styles.fullWidth
                )}
            >
                <img
                    alt=""
                    className={classNames(
                        dibsCss.absolute,
                        dibsCss.hFull,
                        dibsCss.wFull,
                        dibsCss.objectCover
                    )}
                    sizes={`(max-width: 768px) 100vw, ${fullWidth ? '620' : '1316'}px`}
                    srcSet={getSrcsetString(mainImage)}
                    src={mainImage}
                />
            </div>
            <span
                className={classNames(
                    dibsCss.sassyFontSubHeader,
                    dibsCss.ptSmall,
                    dibsCss.px0,
                    dibsCss.pbXxsmall
                )}
            >
                {heading}
            </span>
            <span className={styles.subHeading}>{subHeading}</span>
        </>
    );

    const containerClassName = classNames(styles.container, dibsCss.flex, dibsCss.flexCol);

    return children ? (
        children({
            className: containerClassName,
            children: tile,
        })
    ) : (
        <div className={containerClassName}>{tile}</div>
    );
};
